<template lang="pug">
    div.termsBanner(v-if="!acceptTerms")
      b-container.p-3
        .row
          .col-md-10
            h4 COOKIES & GENERAL TERMS OF USE
            p
             | Your use of this website is governed by
             | the terms and conditions contained in Wall Collective’s general terms and conditions, artist
             | submission terms, rental terms and conditions and privacy policy which is available
             | at www.wallcollective.co/legal. By using this website
             | and/or registering a user account on this website, you acknowledge that you have read,
             | understood and agree to be bound to the terms and conditions contained in the Website
             | Documents as applicable.
            p
             | We also use cookies to compile analytics and improve user experience on this platform.
          .col-md-2.center-xy
            b-button(@click="acceptTermsNow()") ACCEPT
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'alert',
  data() {
    return {

    };
  },
  computed: {
    ...mapState('account', ['acceptTerms']),
  },
  methods: {
    ...mapMutations('account', ['acceptTermsNow']),
  },
};
</script>

<style lang="scss" scoped>
.termsBanner {
  background: rgba(white, 0.8);
  z-index: 100000;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/TermsBanner.vue